module.exports = __webpack_public_path__ + "img/IMG_4175.b8ae8210.jpg";